<template>
    <div id="service" class="service">
        <div class="percent">
            <p>-50%</p>
            <p>Limited offer</p>
        </div>
        <div data-name="service-price">
            <p><span>$99 </span><span>$49</span>/month</p>
        </div>
        <div data-name="service-description">
            <ul>
                <li>
                    <Icon icon="ok"/>
                    <p>Multiple Campaigns Management</p>
                </li>
                <li>
                    <Icon icon="ok"/>
                    <p>Unlimited CrossProm Requests</p>
                </li>
                <li>
                    <Icon icon="ok"/>
                    <p>Unlimited Messaging</p>
                </li>
                <!-- uncomment when the feature will be back again -->
                <!-- <li data-name="with-star">
                    <Icon icon="star-pricing"/>
                    <p>Personal CrossProm Recommendations</p>
                </li> -->
                <li data-name="with-star">
                    <Icon icon="star-pricing"/>
                    <p>Get "Featured" for 5 days</p>
                </li>
                <li data-name="with-star">
                    <Icon icon="star-pricing"/>
                    <p>Automatic Kickstarter update posting</p>
                </li>
            </ul>
        </div>
        <div class="price">${{priceData && priceData.price}}</div>
        <div class="d-flex">
            <p 
                class="price-chip"
                :class="{'selected': priceData && priceData.priceId === value.priceId}"
                :key="value.priceId" 
                v-for="value in stripePrices" 
                @click="setPrice(value)">{{value.days}}
            </p>
        </div>
        <div class="service-buttons d-flex justify-content-center">
            <CheckoutButton
                id="pricing-upgrade-now-button" 
                location = "Pricing Page"
                btn-text = "Upgrade Now"
                :price = "priceData"
                class-name="priceStartNow" />
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import CheckoutButton from '../../components/CheckoutButton'
import {mapState, mapGetters} from 'vuex'
import Button from '../../components/Theme/Button'

export default {
    name: 'Service',
    components: {
        Icon,
        CheckoutButton,
        Button
    },
    computed: {
        ...mapState(['user', 'stripePrices', 'publishedCampaignIds']),
        ...mapGetters(['membershipStatus'])
    }, 
    data(){
        return {
            priceData: null
        }
    },
    mounted(){

        if(!this.publishedCampaignIds.length || !this.user) {
            return this.priceData = this.stripePrices[0]
        }

        this.bestOffer = true
        const userCampaigns = this.publishedCampaignIds.sort((a,b)=> b.created_at.seconds - a.created_at.seconds)
        const newestCampaignsDaystogo = userCampaigns[0].daystogo
        if(newestCampaignsDaystogo > 0 && newestCampaignsDaystogo < 20) {
            this.priceData = this.stripePrices[0]
        } else if(newestCampaignsDaystogo >= 20 && newestCampaignsDaystogo < 35) {
            this.priceData = this.stripePrices[1]
        } else {
            this.priceData = this.stripePrices[2]
        }
    },
    methods: {
        showModal(){
            this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                openedFrom: 'Pricing Page Subscription',
                chosenPlanOnSignup: {
                    name: 'premium',
                    precId: this.priceDat.price
                }
            }]);
        },
        setPrice(selectedOption){
            this.priceData = selectedOption;
        },
    }
}
</script>

<style lang="scss" scoped>
$desktop_width: 488px;
$tab_width: 360px;
$mob_width: 100%;
$desktop_fontsize: 18px;
$mob_fontsize: 16px;
$desktop_paddingtop: 46px;
$mob_paddingtop: 28px; 
$desktop_paddingleft: 43px;
$desktop_paddingright: 43px;
$tab_paddingleft: 24px;
$tab_paddingright: 24px;
$desktop_paddingbottom: 32px;
$mob_paddingbottom: 24px; 
$price: 32px;
$price_weight: 700;
$white: #ffffff;
$primary: #727CF5;
$percent_desktopsize: 34px; 
$percent_mobsize: 24px; 
$weight_700: 700;
$percent_desc_desktop: 13px;
$percent_desc_mob: 11px;
$weight_600: 600;
$fontsize_19: 19px;
$button: 200px;
$button_mob: 100%;

div.service {
    width: $desktop_width;
    background: $primary;
    border-radius: 10px;
    box-shadow: 0px 4px 20px rgba(114, 124, 245, 0.85);
    padding-top: $desktop_paddingtop;
    padding-left: $desktop_paddingleft;
    padding-left: $desktop_paddingright;
    padding-bottom: $desktop_paddingbottom;
    position: relative;
    overflow: hidden;


    div.overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #ffffff96;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .percent {
        position: absolute;
        top: 16px;
        right: 18px;
        z-index: 3;
        p {
            &:first-child {
                font-size: $percent_desktopsize;
                font-weight: $weight_700;
            }
            &:last-child {
                font-size: $percent_desc_desktop;
                font-weight: bold;
                margin-top: 8px;
            }
        }
    }
    &::after {
        content: '';
        position: absolute;
        width: 223px;
        height: 223px;
        border: 1px solid $white;
        border-radius: 50%;
        background: #FA5C7C;
        top: 0;
        left: 100%;
        transform: translate(-156px, -131px)
    }
    p {
        color: $white;
        margin-bottom: 0;
    }
    div[data-name="service-price"] {
        position: relative;
        &::before {
            content: '';
            position: absolute;
            width: 30px;
            height: 3px;
            background: $white;
            top: 100%;
            left: 0;
            transform: translate(0, 10px);
        }
        p {
            font-size: $mob_fontsize;
            span {
                &:first-child {
                    font-size: $fontsize_19;
                    font-weight: $weight_600;
                    text-decoration-line: line-through;
                    text-decoration-color: red;
                    text-decoration-thickness: 2px;
                    -webkit-user-select: none;  
                    -moz-user-select: none;    
                    -ms-user-select: none;      
                    user-select: none;
                }
                &:last-child {
                    font-size: $price;
                    font-weight: $weight_700;
                }
            }
        }
    }
    div[data-name="service-description"] {
        margin-top: 40px;
    
        ul {
            padding: 0;
            li {
                display: flex;
                margin-bottom: 20px;
                &[data-name="with-star"] {
                    &:last-child {
                        margin-bottom: 0;
                    }
                    p {
                        font-weight: bold;
                    }
                }
                p {
                    font-size: $desktop_fontsize;
                    margin-left: 10px;
                }
            }
        }
    }
    .price {
        text-align: center;
        font-size: 50px;
        margin: 40px 0;
    }
    .service-buttons {
        padding-right: 43px;
    }
    .price-chip {
        width: 200px;
        background: orange;
        font-size: 30px;
        margin: 30px;
        cursor: pointer;
        &.selected {
            background: #FA5C7C;
        }
    }
    button {
        width: 200px;
        height: 48px;
        margin-top: 20px;
        
        @media screen and (min-height: 900px) {
            margin-top: 46px;
        }
    }
}
@media (max-width: 576px) {
    div.service {
        width: $mob_width !important;
        padding-top: $mob_paddingtop;
        padding-right: $tab_paddingright;
        padding-left: $tab_paddingleft;
        padding-bottom: $mob_paddingbottom;
    }
}
@media (max-width: 768px) {
div.service {
    width: $tab_width;
    padding-top: $mob_paddingtop;
    padding-right: $tab_paddingright;
    padding-left: $tab_paddingleft;
    padding-bottom: $mob_paddingbottom;

    .percent {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 3;
        p {
            &:first-child {
                font-size: $percent_mobsize;
                font-weight: $weight_700;
            }
            &:last-child {
                font-size: $percent_desc_mob;
                font-weight: bold;
                margin-top: 8px;
            }
        }
    }
    &::after {
        transform: translate(-125px, -144px);
    }
    div[data-name="service-description"] {
        margin-top: 24px;
    
        ul {
            li {
                p {
                    font-size: $mob_fontsize;
                    margin-left: 10px;
                }
            }
        }
    }
    button {
        margin-top: 32px;
        width: $button_mob;
    }
}
    
}
</style>